import { render, staticRenderFns } from "./SupplierIdentityVerification.vue?vue&type=template&id=e7283cf8&"
import script from "./SupplierIdentityVerification.vue?vue&type=script&lang=js&"
export * from "./SupplierIdentityVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports